/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `NotificationList.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { NotificationList } from "./NotificationList";

import { NotificationListsUser } from "./NotificationListsUser";
import { Project } from "./Project";

export abstract class NotificationListModel {
    id: number;
    createdAt: Dayjs;
    notificationListableId: number;
    notificationListableType: string;
    projectId: number;
    updatedAt: Dayjs;
    notificationListsUsers: NotificationListsUser[] | undefined;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        notificationListableId: number,
        notificationListableType: string,
        projectId: number,
        updatedAt: Dayjs,
        notificationListsUsers: NotificationListsUser[] | undefined,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.notificationListableId = notificationListableId;
        this.notificationListableType = notificationListableType;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.notificationListsUsers = notificationListsUsers;
        this.project = project;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): NotificationList {
        const newObject = new NotificationList(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["notification_listable_id"],
            json["notification_listable_type"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["notification_lists_users"]?.map((item: any) => NotificationListsUser.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            notification_listable_id: this.notificationListableId,
            notification_listable_type: this.notificationListableType,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            notification_lists_users: this.notificationListsUsers?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): NotificationList {
        const clone = Object.create(this) as NotificationList;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
